import React from 'react';
import routes from './routes';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { hot } from 'react-hot-loader';

interface AppType {
  history: any;
  store: any;
}

const App: React.FC<AppType> = ({ history, store }) => (
  <Provider store={store}>
    <PersistGate loading="loading..." persistor={store.presistor}>
      <ConnectedRouter history={history}>{renderRoutes(routes)}</ConnectedRouter>
    </PersistGate>
  </Provider>
);

export default hot(module)(App);
